import { call, put } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import * as action from '../actions/so';
import { post, axiosPut, get } from '../../utils/api';
import { modalErrorOpen } from '../actions/modalError';
import { modalShipmentSZRebindingClose } from '../actions/modal';

export function* getSO({ payload }) {
  try {
    const response = yield call(post, '/grid/arbitration/so/', {
      ...payload
    });
    yield put(action.getSOSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message || `${formatMessage('textTableAdminMessages').status} ${error.response.data.status}`,
        techInfo: error.response.data.techInfo || error.response.data.error,
        types: 'error',
        title: formatMessage('error')
      })
    );
    yield put(action.getSOFail());
  }
}

export function* getSORP({ payload }) {
  try {
    const response = yield call(post, '/grid/arbitration/so/ready_product/', {
      ...payload
    });
    yield put(action.getSORPSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message || `${formatMessage('textTableAdminMessages').status} ${error.response.data.status}`,
        techInfo: error.response.data.techInfo || error.response.data.error,
        types: 'error',
        title: formatMessage('error')
      })
    );
    yield put(action.getSORPFail());
  }
}

export function* rebindSORP({ payload }) {
  try {
    yield call(axiosPut, '/piece/rebinding', {
      needToBeUntied: payload.needToBeUntied,
      pieceNumIds: [...payload.pieceNumIds],
      solNumId: payload.solNumId
    });
    if (payload.needToBeUntied) {
      const responseSO = yield call(post, '/grid/arbitration/so/', {
        dateFrom: payload.dateFrom,
        dateTo: payload.dateTo,
        filter: payload.filter,
        plantId: payload.plantId
      });
      yield put(action.getSOSuccess(responseSO));
      const responsesORP = yield call(post, '/grid/arbitration/so/ready_product/', {
        salesOrderLineId: payload.solNumId
      });
      yield put(action.getSORPSuccess(responsesORP));
    } else yield put(modalShipmentSZRebindingClose());
    yield put(action.rebindSORPSuccess());
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message || `${formatMessage('textTableAdminMessages').status} ${error.response.data.status}`,
        techInfo: error.response.data.techInfo || error.response.data.error,
        types: 'error',
        title: formatMessage('error')
      })
    );
    yield put(action.rebindSORPFail());
  }
}

export function* getSOForRebind({ payload }) {
  const params = payload.join('&pieceNumIds=');
  try {
    const response = yield call(get, `/grid/arbitration/so/binding/list/?pieceNumIds=${params}`);
    yield put(action.getSOForRebindSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message || `${formatMessage('textTableAdminMessages').status} ${error.response.data.status}`,
        techInfo: error.response.data.techInfo || error.response.data.error,
        types: 'error',
        title: formatMessage('error')
      })
    );
    yield put(action.getSOForRebindFail());
  }
}
